import { status } from '../../config.ts'
import { wait } from '@/__mocks__/util/async.ts'
import { rentabilityConfigurationList } from './rentabilityConfigurationData.ts'

export default [
  {
    method: 'GET',
    path: '/insurance_rentability',
    reply: async () => {
      await wait()
      return [status.ok, rentabilityConfigurationList]
    }
  },
  {
    method: 'POST',
    path: '/insurance_rentability',
    reply: async () => {
      await wait()
      return [status.ok, { message: 'Configuración creada' }]
    }
  },
  {
    method: 'PATCH',
    path: /\/insurance_rentability\/\d+$/,
    reply: async () => {
      await wait()
      return [status.ok, { message: 'Configuración actualizada' }]
    }
  },
  {
    method: 'PATCH',
    path: /\/insurance_rentability\/\d+\/status$/,
    reply: async () => {
      await wait()
      return [status.ok, { message: 'Estado actualizado' }]
    }
  }
]
